<div class="wrapper">
  <!-- Sidebar -->
  <nav id="sidebar" class="{{ active ? 'active' : '' }}">
    <div class="sidebar__content">
      <figure>
        <img src="/assets/images/logo.svg" alt="Logo">
        <button class="{{ active ? 'show' : 'hide' }}" (click)="showSidebar()">
          <img src="/assets/images/icon-close.svg" alt="Cerrar">
        </button>

      </figure>
      <h2>Versiones términos y condiciones</h2>
      <div class="sidebar__items">
        <ul>
          <li *ngFor="let version of versions; let i = index" [class.active]="selectedVersionIndex === i"
            (click)="selectVersion(i)" (mouseenter)="highlightVersion(i)" (mouseleave)="resetHighlight()">
            <a (click)="selectVersion(i)">
              <div class="version-name">{{ version.title }}</div>
              <div class="version-date">{{ version.date }}</div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- Page Content -->
  <div id="content">
    <div style="display: flex;">
      <div>
        <button class="button-toggle" (click)="showSidebar()">Ver historial de versiones</button>
      </div>
      <div>
        <img style="width: 35px; cursor: pointer; margin-left: 5px;" (click)="download()" src="/assets/images/down.png"
          alt="down">
      </div>
    </div>
    <br>
    <br>
    <br>
    <div>
      <!-- Iframes manuales con URL directamente escrita -->
      <!-- <div>
              <embed *ngIf="selectedVersionIndex === 0"
                src="http://triidy.com/wp-content/uploads/2024/02/TERMINOS-Y-CONDICIONES-V-Febrero-2024.pdf" width="100%"
                height="600px" type="application/pdf">
              <embed *ngIf="selectedVersionIndex === 1"
                src="http://triidy.com/wp-content/uploads/2024/02/TERMINOS-Y-CONDICIONES-V-Noviembre-2023.pdf" width="100%"
                height="600px" type="application/pdf">
              <embed *ngIf="selectedVersionIndex === 2"
                src="http://triidy.com/wp-content/uploads/2024/02/TERMINOS-Y-CONDICIONES-V-Julio-2020.pdf" width="100%" height="600px"
                type="application/pdf">

              Se agrega más iframes según sea necesario
            </div> -->
      <div *ngIf="selectedVersionIndex === 0" class="pdf-container">
        <div *ngFor="let imagePath of version4">
          <img [src]="imagePath" alt="PDF Page" class="pdf-image recortada">
        </div>
        <div *ngFor="let imagePath of version4_1">
          <img [src]="imagePath" alt="PDF Page" class="pdf-image recortada">
        </div>
      </div>
      <div *ngIf="selectedVersionIndex === 3" class="pdf-container">
        <div *ngFor="let imagePath of version3">
          <img [src]="imagePath" alt="PDF Page" class="pdf-image recortada">
        </div>
        <div *ngFor="let imagePath of version3_1">
          <img [src]="imagePath" alt="PDF Page" class="pdf-image recortada">
        </div>
      </div>
      <div *ngIf="selectedVersionIndex === 2" class="pdf-container">
        <div *ngFor="let imagePath of version2">
          <img [src]="imagePath" alt="{{imagePath}}" class="pdf-image recortada2 ">
        </div>
      </div>
      <div *ngIf="selectedVersionIndex === 1" class="pdf-container">
        <div *ngFor="let imagePath of version1">
          <img [src]="imagePath" alt="PDF Page" class="pdf-image recortada2">
        </div>
      </div>
    </div>
  </div>
